__turbopack_context__.v({
  "arrow": "BlogRelated-module__u5--KW__arrow",
  "excerpt": "BlogRelated-module__u5--KW__excerpt",
  "list": "BlogRelated-module__u5--KW__list",
  "main": "BlogRelated-module__u5--KW__main",
  "meta": "BlogRelated-module__u5--KW__meta",
  "metaDot": "BlogRelated-module__u5--KW__metaDot",
  "name": "BlogRelated-module__u5--KW__name",
  "related": "BlogRelated-module__u5--KW__related",
  "row": "BlogRelated-module__u5--KW__row",
  "title": "BlogRelated-module__u5--KW__title",
});
